import Head from 'next/head';

export default function Linkaufbau() {
    return (
        <div className="flex flex-col min-h-screen bg-gray-100 dark:bg-gray-900">
            <Head>
                <title>Linkaufbau | deinSEOExpert</title>
                <link rel="icon" href="/favicon.ico"/>
                <meta
                    name="description"
                    content="Entdecken Sie mein Linkaufbau Service und erfahren Sie mehr über meine professionellen SEO-Dienstleistungen. Als Ihr SEO-Experte biete ich maßgeschneiderte Lösungen und kompetente Beratung, um Ihren SEO-Erfolg zu maximieren. Besuchen Sie meine Website für Expertenwissen und gezielte Keyword-Optimierung."
                />
            </Head>

            <main className="p-6 flex flex-col-reverse md:flex-row max-w-5xl mx-auto">
                <div className="w-full md:w-2/3 pr-4 mb-4 md:mb-0 order-2 md:order-1">
                    <div className="flex items-center mb-6">
                        <span className="inline-block mr-4 text-4xl">🔗</span>
                        <h2 className="text-3xl font-bold text-green-700">Linkaufbau</h2>
                    </div>
                    <p className="text-lg leading-relaxed text-gray-700 mb-10 dark:text-white">Ich helfe Ihnen, qualitativ hochwertige
                        Backlinks zu gewinnen, um die Autorität Ihrer Website zu erhöhen und Ihre Positionen in den
                        Suchmaschinen zu verbessern. Durch den Aufbau eines starken Backlink-Profils können Sie Ihre
                        Online-Präsenz stärken, mehr Traffic auf Ihre Website leiten und letztendlich Ihr Geschäft
                        ausbauen.</p>

                    <h2 className="text-2xl font-bold text-green-700 mb-4">Warum ist Linkaufbau wichtig?</h2>
                    <p className="text-lg leading-relaxed text-gray-700 dark:text-white">Linkaufbau ist eine wesentliche Komponente
                        jeder SEO-Strategie. Ein starkes Backlink-Profil kann Ihrer Website helfen, in den Suchmaschinen
                        besser zu ranken, mehr Traffic zu generieren und Ihre Online-Präsenz zu stärken. Durch meine
                        Linkaufbau-Dienstleistungen kann ich Ihre SEO-Bemühungen unterstützen und Ihnen helfen, Ihre
                        Geschäftsziele zu erreichen. Backlinks sind im Grunde Empfehlungen von anderen Websites und ein
                        wichtiger Faktor, wie Suchmaschinen die Relevanz und Autorität Ihrer Website bewerten.</p>
                </div>

                <div className="w-full md:w-1/3 pl-4 order-1 md:order-2">
                    <div className="bg-white p-6 rounded shadow-md dark:bg-gray-800">
                        <img src="/link.png" alt="Dein SEO Experte" className="w-full mb-6 rounded"/>
                        <h3 className="text-xl font-bold text-green-700 mb-2 ">Dein SEO Experte</h3>
                        <p className="text-gray-700 mb-4 dark:text-white">Als Ihr SEO-Experte, spezialisiert auf den Aufbau
                            von qualitativ hochwertigen Backlinks, bringe ich jahrelange Erfahrung und
                            fundiertes Fachwissen mit, um Ihre Website auf die nächste
                            Stufe zu bringen.</p>
                    </div>
                </div>
            </main>
        </div>
    );
}